// extracted by mini-css-extract-plugin
export default {"noResultsBoilerPlate":"Common_noResultsBoilerPlate__6qQqx"};